module.exports = "/images/eula_hero.svg?da253e0749e3f87a19cdb56eea6c37ed";